import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-x-3 gap-y-2 w-full" }
const _hoisted_2 = { class: "flex-grow" }
const _hoisted_3 = { class: "text-left font-semibold text-3xl pb-0 whitespace-nowrap" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_5 = { class: "flex space-x-4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PigTypePicker = _resolveComponent("PigTypePicker")!
  const _component_PeriodRangeDropdown = _resolveComponent("PeriodRangeDropdown")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "above-heading"),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.heading), 1),
      _renderSlot(_ctx.$slots, "subheading", {}, () => [
        (_ctx.subheading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.subheading), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.hasPigTypePicker)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_PigTypePicker, { slim: _ctx.slimPigTypePicker }, null, 8, ["slim"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasPeriodPicker)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_PeriodRangeDropdown, {
              value: _ctx.periodPickerDateString,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.periodPickerDateString) = $event))
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top-right")
    ])
  ]))
}